import { useTracking } from '@change-corgi/core-react/tracking';

import { useLocationSitemapPageData } from '#src/app/pages/locationSitemap/pageContext';
import type { Locations } from '#src/app/pages/locationSitemap/pageContext';

type Result = ModelHookResult<
	{
		locations: Locations;
		hasNextPage: boolean;
		nextPageLoading: boolean;
		totalCount: number;
	},
	{
		loadMore: () => void;
	}
>;

export function useFilterableLocations(): Result {
	const {
		data: { hasNextPage, items: locations, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useLocationSitemapPageData();
	const track = useTracking();

	return {
		data: {
			locations,
			hasNextPage,
			totalCount,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('local_sitemap_show_more');
				loadMore();
			},
		},
	};
}
